module.exports = "<input type=\"text\" id=\"{{vm.inputId}}\" ng-model=\"vm.valueinput\" class=\"form-control dvDatepicker\" ng-change=\"vm.removeNotDigits()\" ng-blur=\"vm.updateModelValueBlur()\" ng-focus=\"vm.handleFocus($event)\" ng-required=\"vm.valueRequired\" ng-trim=\"false\" ng-disabled=\"vm.ngDisabled\" name=\"{{vm.inputName}}\"/> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directive/dv-valueinput/dv-valueinput.html
// module id = HgSf
// module chunks = 0